import React from 'react';

import colors from '@constants/colors';

function Calculator() {
	return (
		<svg
			fill='none'
			height='16'
			viewBox='0 0 16 16'
			width='16'
		>
			<path
				d='M14.75 1.25H1.25C1.05116 1.25023 0.860528 1.32932 0.719926 1.46993C0.579324 1.61053 0.500232 1.80116 0.5 2V14C0.500232 14.1988 0.579324 14.3895 0.719926 14.5301C0.860528 14.6707 1.05116 14.7498 1.25 14.75H14.75C14.9488 14.7498 15.1395 14.6707 15.2801 14.5301C15.4207 14.3895 15.4998 14.1988 15.5 14V2C15.4998 1.80116 15.4207 1.61053 15.2801 1.46993C15.1395 1.32932 14.9488 1.25023 14.75 1.25ZM14.6667 14H1.33333V2H14.6667V14Z'
				fill={colors.indigo70}
			/>
			<path
				clipRule='evenodd'
				d='M5.33398 7.33333H4.66732V6H3.33398V5.33333H4.66732V4H5.33398V5.33333H6.66732V6H5.33398V7.33333ZM12.5007 5.25H9.00065V6H12.5007V5.25ZM12.5007 9.33333H9.00065V10H12.5007V9.33333ZM12.5007 10.6667H9.00065V11.3333H12.5007V10.6667ZM5.96715 11.7712L6.43855 11.2998L5.49574 10.357L6.43855 9.41421L5.96715 8.94281L5.02434 9.88562L4.08153 8.94281L3.61013 9.41421L4.55294 10.357L3.61013 11.2998L4.08153 11.7712L5.02434 10.8284L5.96715 11.7712Z'
				fill={colors.indigo70}
				fillRule='evenodd'
			/>
		</svg>
	);
}

export default Calculator;
